import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { STATUS_INITIAL, STATUS_LOADING, STATUS_SUCCEEDED } from 'myParkdUtils/constants';
import { RegistrationUserData, Status, User, UserDTO } from 'types';
import { authSlice } from '../../features/auth/authSlice';


export type UserReducerState = {
    user: User | null;
    userCreateStatus: Status;
    userGetStatus: Status;
    userUpdateStatus: Status;
};

export const initialUserReducerState: UserReducerState = {
    user: null,
    userCreateStatus: STATUS_INITIAL,
    userGetStatus: STATUS_INITIAL,
    userUpdateStatus: STATUS_INITIAL
};

export const userSlice = createSlice({
    name: 'user',
    initialState: initialUserReducerState,
    reducers: {
        //---------------------------------------------------------------------------------------------
        createUser(state, action: PayloadAction<{ user: RegistrationUserData }>) {
            state.userCreateStatus = STATUS_LOADING;
        },
        createUserCompleted(state, action: PayloadAction<{ user: RegistrationUserData }>) {
            state.userCreateStatus = STATUS_SUCCEEDED;
        },
        createUserError(state, action: PayloadAction<{ error: any }>) {
            state.userCreateStatus = {
                ...STATUS_INITIAL,
                error: action.payload.error
            }
        },
        //---------------------------------------------------------------------------------------------
        getUser(state) {
            state.userGetStatus = STATUS_LOADING
        },
        getUserCompleted(state, action: PayloadAction<{ user: User }>) {
            state.user = action.payload.user;
            state.userGetStatus = STATUS_SUCCEEDED;
        },
        getUserError(state, action: PayloadAction<{ error: any }>) {
            state.userGetStatus = {
                ...STATUS_INITIAL,
                error: action.payload.error
            }
        },
        //---------------------------------------------------------------------------------------------
        saveUser(state, action: PayloadAction<{ user: UserDTO }>) {
            state.userUpdateStatus = STATUS_LOADING;
        },
        saveUserCompleted(state, action: PayloadAction<{ user: UserDTO }>) {
            state.userUpdateStatus = STATUS_SUCCEEDED;
            state.user = {
                ...state.user,
                ...action.payload.user
            } as User
        },
        saveUserError(state, action: PayloadAction<{ error: any }>) {
            state.userUpdateStatus = {
                ...STATUS_INITIAL,
                error: action.payload.error
            }
        },
        //---------------------------------------------------------------------------------------------
    },
    extraReducers: (builder) => {
        builder.addCase(authSlice.actions.loginCompleted, (state, action) => {
            state.user = action.payload.user
        })
    },
    selectors: {
        getUser: (state) => state.user
    },
});

export const {
    getUser,
    getUserCompleted,
    getUserError,
    saveUser,
    saveUserCompleted,
    saveUserError,
    createUser,
    createUserCompleted,
    createUserError
} = userSlice.actions;

export default userSlice.reducer;
